import get from 'lodash/get'

import { IFlowTrigger } from 'common/flow/flowInterfaces'
import {
  TriggerConfigType,
  TriggersDictionary,
  TriggersDictionaryFlowBuilder,
} from 'shared/lib/triggers/constants/dictionary'

export const getTriggerConfig = (trigger: IFlowTrigger): TriggerConfigType | null => {
  const isWidget = 'widget_type' in trigger

  const type = isWidget ? trigger.widget_type : trigger.triggerType

  if (type) {
    if ('channel' in trigger) {
      return get(TriggersDictionary, [trigger.channel, type], {}) as TriggerConfigType
    }

    return get(TriggersDictionaryFlowBuilder, [type], {}) as TriggerConfigType
  }

  return null
}
